module.exports = __webpack_public_path__ + "img/cuxiao-buy.2d44f2d4.svg";